/** @format */
import { MarketLanguage } from '@mpb-com/feather/enums';

import { languagesWithImpressum } from '../config/language';

export const hasImpressum = (language: MarketLanguage) => {
    return languagesWithImpressum.includes(language);
};
